export default __webpack_public_path__ + "static/media/logo web.945e7e42.svg";